import { get } from "./get"

export * as Get from "./get/types"

export function set(pageId: string) {
  return {
    get: get(pageId),
  }
}
